import styled from "styled-components";
import { m as Motion } from "framer-motion";

export const Arrow = styled.div`
  /* &,
  &::before {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 2px;
    z-index: -1;
  }

  &::before {
    content: "";
    transform: rotate(45deg);
    background: ${({ theme }) => theme.tooltip.background};
  } */
`;

export const StyledTooltip = styled(Motion.div)`
  padding: 8px;
  font-size: 10px;
  line-height: 16px;
  z-index: 101;
  background: #161c1c;
  border: 1px solid rgba(250, 255, 255, 0.1);
  max-width: 230px;

  ${({ theme }) => theme.mediaQueries.md} {
    max-width: 380px;
  }

  &[data-popper-placement^="top"] > ${Arrow} {
    bottom: -4px;
  }

  &[data-popper-placement^="bottom"] > ${Arrow} {
    top: -4px;
  }

  &[data-popper-placement^="left"] > ${Arrow} {
    right: -4px;
  }

  &[data-popper-placement^="right"] > ${Arrow} {
    left: -4px;
  }
`;
